import Departments from "./Departments.jsx";

export default Departments;
